import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Release gate for CollectivIQ University (/learn). Mirrors the DDR gate: the
 * backend resolves the `learn-release-enabled` LaunchDarkly flag into
 * /users/me (`learn_enabled`), and this keeps the route unreachable when the
 * flag is off. Fails closed (redirects to /chat) for cached sessions that
 * predate the field. The backend independently 403s /learn/* as the
 * authoritative gate.
 */
export const learnReleaseGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.learnEnabled()) {
        return true;
    }
    return router.createUrlTree(['/chat']);
};
